module.exports = __webpack_public_path__ + "img/hr-bigass-explosion-36f-1.25557241.png";